// src/icons/svgs/link.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgLink = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 18, fill: "none", viewBox: "0 0 8 18", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.993 1.7a2.626 2.626 0 0 1 2.626 2.626v1.777a.5.5 0 0 0 1 0V4.326a3.626 3.626 0 1 0-7.252 0v1.777a.5.5 0 0 0 1 0V4.326A2.626 2.626 0 0 1 3.993 1.7m0 14.6a2.626 2.626 0 0 0 2.626-2.626v-1.778a.5.5 0 0 1 1 0v1.778a3.626 3.626 0 1 1-7.252 0v-1.778a.5.5 0 0 1 1 0v1.778A2.626 2.626 0 0 0 3.993 16.3M4.5 5a.5.5 0 1 0-1 0v8a.5.5 0 1 0 1 0z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgLink);
var link_default = ForwardRef;
export {
  link_default as Link
};
